import { ReactNode } from 'react';

export const FundingRequirementsPageShell = ({
    sidePanel,
    progressIndicator,
    mainContent
}: {
    sidePanel: ReactNode;
    progressIndicator: ReactNode;
    mainContent: ReactNode;
}) => (
    <div className="flex flex-col bg-structure-100 min-m:flex-row">
        <div className="relative hidden max-w-[420px] grow bg-primary-10 text-structure-100 min-m:block">
            <div className="sticky bottom-0 top-header-offset flex min-h-[calc(100dvh-var(--header-offset))] flex-col gap-2xl p-4xl">
                {sidePanel}
            </div>
        </div>
        <div className="grow p-xl">
            <div className="py-xl">{progressIndicator}</div>
            {mainContent}
        </div>
    </div>
);
